import myAxiosV2 from "./apiV2";

const baseUrl = "/admin";

const VideoPrompt = {
  // Get all existing video prompts
  // GET /api/v1/videoPrompt
  getAll(query = null) {
    return myAxiosV2.get(`${baseUrl}/videoPrompt?${query ? query : ""}`);
  },

  // Get video prompt by ID
  // GET /api/v1/videoPrompt/{id}
  getById(id) {
    return myAxiosV2.get(`${baseUrl}/videoPrompt/${id}`);
  },

  // Get video prompts by location ID
  // GET /api/v1/videoPrompt/location/{locationId}
  getByLocationId(locationId) {
    return myAxiosV2.get(`${baseUrl}/videoPrompt/location/${locationId}`);
  },

  // Create new video prompts (POST array of prompts)
  // POST /api/v1/videoPrompt
  // Payload: [{ locationId: [1,2], prompt: "..." }]
  create(data) {
    return myAxiosV2.post(`${baseUrl}/videoPrompt`, data);
  },

  // Update existing video prompt by ID
  // PUT /api/v1/videoPrompt/{id}
  // Payload: { locationIds: [1,3], prompt: "..." }
  update(id, data) {
    return myAxiosV2.put(`${baseUrl}/videoPrompt/${id}`, data);
  },

  // Delete video prompt by ID
  // DELETE /api/v1/videoPrompt/{id}
  delete(id) {
    return myAxiosV2.delete(`${baseUrl}/videoPrompt/${id}`);
  },

  // Video Prompt Groups endpoints
  // Get all video prompt groups
  // GET /api/v1/video-prompt-groups
  getVideoPromptGroups() {
    return myAxiosV2.get(`/video-prompt-groups`);
  },

  // Create new video prompt group
  // POST /api/v1/video-prompt-groups
  // Payload: { name: "Technical Prompts" }
  createVideoPromptGroup(data) {
    return myAxiosV2.post(`/video-prompt-groups`, data);
  },

  // Update video prompt group
  // PUT /api/v1/video-prompt-groups/{id}
  // Payload: { name: "HR Prompts" }
  updateVideoPromptGroup(id, data) {
    return myAxiosV2.put(`/video-prompt-groups/${id}`, data);
  },

  // Delete video prompt group
  // DELETE /api/v1/video-prompt-groups/{id}
  deleteVideoPromptGroup(id) {
    return myAxiosV2.delete(`/video-prompt-groups/${id}`);
  },
};

export default VideoPrompt;
